const CASE_INSERT_TYPES = {
  CASE_START_NEW: { id: 0, value: 'Πρωτοείσακη' },
  CASE_START_CONTINUED: { id: 1, value: 'Εξ αναβολής' },
  CASE_START_REPEAT: { id: 2, value: 'Επανάληψη' },
  CASE_UNKNOWN: { id: 3, value: ' -' }
}

const CASE_END_TYPES = {
  CASE_END_POSTPONED: { id: 0, value: 'Αναβολή' },
  CASE_END_IN_DISCUSSION: { id: 1, value: 'Συζητείται' },
  CASE_END_VIOLENTLY: { id: 2, value: 'Βίαιη διακοπή' },
  CASE_END_CANCELED: { id: 3, value: 'Ματαιούται' },
  CASE_END_RECONCILIATION: { id: 4, value: 'Συμβιβασμός' },
  CASE_END_ATTORNEY_RESIGN: { id: 5, value: 'Παραίτηση δικηγόρου' },
  CASE_END_POSTPONED_OPPOSITE: { id: 6, value: 'Αναβολή με αντιδικία' },
  CASE_END_POSTPONED_CONSENSUS: { id: 7, value: 'Αναβολή συναινετική' },
  CASE_END_CASEWRITER_RESIGN: { id: 8, value: 'Παραίτηση δικογράφου' },
  CASE_END_ABOLITION_TRIAL: { id: 9, value: 'Κατάργηση δίκης' },
  CASE_END_WITHOUT_PRONUNCIATION: { id: 10, value: 'Χωρίς εκφώνηση' }
}

export const getCaseInsertTypeById = (id) => {
  return Object.values(CASE_INSERT_TYPES).find((type) => type.id === id)
}

export const getCaseInsertTypeByValue = (value) => {
  return Object.values(CASE_INSERT_TYPES).find((type) => type.value === value)
}

export const getCaseInsertTypeOptions = () => {
  return Object.values(CASE_INSERT_TYPES).map(({ id, value }) => ({
    insertTypeId: id,
    insertTypeValue: value
  }))
}

export const getCaseEndTypeById = (id) => {
  return Object.values(CASE_END_TYPES).find((type) => type.id === id)
}

export const getCaseEndTypeByValue = (value) => {
  return Object.values(CASE_END_TYPES).find((type) => type.value === value)
}

export const getCaseEndTypeOptions = () => {
  return Object.values(CASE_END_TYPES).map(({ id, value }) => ({
    endTypeId: id,
    endTypeValue: value
  }))
}
